export const NEW_ROUTE_MAP = {
  memberNews: '/membernews/',
  logisticsNews: '/news/',
  jctransNews: '/jctransnews/',
  blog: '/blog/',
  blogDetail: '/blog/',
  knowledge: '/news-knowledge/',
}
